<template>
	<div class="box">
		<div>
			<h2>{{ installable.title }}</h2>
		</div>
		<div class="pt-4">
			<div class="flex-space-between--center flex-column">
				<div class="flex text-align-left">
					<h4>
						Want to add installable to your marketplace listings? Contact your service provider and tell him the installable id you want to
						list
					</h4>
				</div>
				<div class="flex flex-align-center pt-4">
					<div class="id-input"><AppTextField readonly :value="installable.id" class="link-input" /></div>
					<div class="inline-link-style ml-3 small" @click="copyInput(installable.id, 'ID')">Copy ID</div>
				</div>
			</div>
			<div class="flex-space-between--center pt-3">
				<div class="flex-1"><AppTextField readonly :value="installableUrl" class="link-input" /></div>
				<div class="flex-space-between--center flex-column ml-3">
					<div class="inline-link-style" @click="copyInput(installableUrl, 'URL')">Copy Link</div>
					<div class="inline-link-style" @click="goToUrl">Open listing</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'InstallableDetailsBox',
	props: {
		installable: { type: Object },
	},
	computed: {
		installableUrl() {
			const featureContextService = this.installable.feature_context_service;
			const basePath = featureContextService ? `apps/${featureContextService.service_slug}` : 'marketplace';
			return `${process.env.VUE_APP_MARKETPLACE_URL}${basePath}/listing/${this.installable.listing_slug}/${this.installable.id}/`;
		},
	},
	methods: {
		copyInput(input, name) {
			navigator.clipboard.writeText(input);
			this.$toast.success(`Copied ${name}`);
		},
		goToUrl() {
			window.open(this.installableUrl, '_blank');
		},
	},
};
</script>

<style lang="scss" scoped>
.box {
	font-size: 12px;
	box-shadow: none !important;
	border: 0;
	padding: 27px 17px;
	background-color: #f0f3f9;
	border-radius: 15px;

	.link-input {
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.inline-link-style {
		color: var(--primary-color);
	}
	.id-input {
		width: 85px;
	}
}
</style>
